import { useCallback } from 'react';
import { Button } from 'src/common/components/button';
import { useOpenModal } from 'src/common/components/next-modal';
import { OpenSettingFrom, SettingMenuType } from 'src/views/main/setting-modal/type';
import { useOpenSettingModal } from 'src/views/main/setting-modal/use-open-setting-modal';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { createActivityModalAnchor } from './create-activity-modal-anchor';

export const useOpenFirstTaskModal = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const openSettingModal = useOpenSettingModal();

  return useCallback(() => {
    const activityModalAnchor = createActivityModalAnchor();

    openModal.dropdown({
      popcorn: activityModalAnchor.popcorn,
      modalId: 'openFirstTaskModal',
      placement: 'top-end',
      offset: [4, 10],
      autoClose: false,
      keyboard: false,
      closeAfterCallBack: activityModalAnchor.remove,
      content: ({ onCloseModal }) => (
        <div className="p-7 next-modal w-80">
          <div>
            <div className="text-h3 mb-2.5">
              {t('components.activities.task_modal.first_task_unlocked')}
            </div>
            <div className="text-t1-medium">
              {t('components.activities.task_modal.first_task_description')}
            </div>
          </div>
          <div className="mt-7 flex items-center">
            <Button className="mr-2.5" onClick={() => onCloseModal()}>
              {t('components.activities.task_modal.learn_later')}
            </Button>
            <Button
              colorType="active"
              onClick={() => {
                onCloseModal();
                openSettingModal({
                  defaultMenuType: SettingMenuType.integral,
                  from: OpenSettingFrom.package,
                });
              }}
            >
              {t('common.view_now')}
            </Button>
          </div>
        </div>
      ),
    });
  }, [openModal, openSettingModal, t]);
};

export const useOpenStageTaskModal = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const openSettingModal = useOpenSettingModal();

  return useCallback(() => {
    const activityModalAnchor = createActivityModalAnchor();

    openModal.dropdown({
      popcorn: activityModalAnchor.popcorn,
      modalId: 'openStageTaskModal',
      placement: 'top-end',
      offset: [4, 10],
      closeAfterCallBack: activityModalAnchor.remove,
      content: ({ onCloseModal }) => (
        <div className="p-7 next-modal w-80">
          <div>
            <div className="text-h3 mb-2.5">
              {t('components.activities.task_modal.stage_task_completed')}
            </div>
            <div className="text-t1-medium">
              {t('components.activities.task_modal.stage_task_description')}
            </div>
          </div>
          <div className="mt-7 flex items-center">
            <Button
              colorType="active"
              onClick={() => {
                onCloseModal();
                openSettingModal({
                  defaultMenuType: SettingMenuType.integral,
                  from: OpenSettingFrom.package,
                });
              }}
            >
              {t('components.activities.task_modal.view_remaining_tasks')}
            </Button>
          </div>
        </div>
      ),
    });
  }, [openModal, openSettingModal, t]);
};
